module.exports = __webpack_public_path__ + "img/virsody-logo-footer.40e0ed15.svg";